import { createSlice } from "@reduxjs/toolkit";
import { UserStateV2 } from "../../../types";
import { getAllEmployeeRoles } from "./api";

const initialState: UserStateV2 = {
    allEmployeeRoles: [],
    isLoadingAllEmployeeRoles: false,
};


export const userSliceV2 = createSlice({
    name: "userV2",
    initialState,
    reducers: {},
    extraReducers: {
        [getAllEmployeeRoles.fulfilled.type]: (state, { payload }) => {
            state.allEmployeeRoles = payload;
            state.isLoadingAllEmployeeRoles = false;
        },
        [getAllEmployeeRoles.pending.type]: (state) => {
            state.isLoadingAllEmployeeRoles = true;
        },
        [getAllEmployeeRoles.rejected.type]: (state) => {
            state.isLoadingAllEmployeeRoles = false;
        },
    },
});


export const {} = userSliceV2.actions;
export default userSliceV2.reducer;
